<form #formReference [formGroup]="form" (ngSubmit)="formService.submit()">

    <div class="panel_title">
        <div class="row marges">
            <div class="col y_items_center">
                <div>
                    <p class="title">{{ 'offer.priceLevel.additional.plural.value' | translate }}</p>
                </div>
            </div>

            <div class="col_content y_items_center">
                <button class="btn_cta btn_lines btn_little" type="button" (click)="close.emit()">
                    {{ 'cancel.value' | translate }}
                </button>
            </div>
            <div class="col_content y_items_center">
                <button class="btn_cta btn_little" type="submit">
                    {{ 'form.submit.action.value' | translate }}
                </button>
            </div>

        </div>
    </div>

    <div class="form_part" *ngIf="offer">

        <div class="ligne_form collection">

            <ng-container formArrayName="priceLevels">
                <br/>
                <div *ngFor="let _ of priceLevelsControl.controls; index as i" class="price-level form-group removable_item">
                    <ng-container [formGroupName]="indexAsString(i)">

                        <div class="row marges ligne_form">

                            <!-- Nom  -->

                            <div class="col_12">
                                <div class="form-group">
                                    <input type="text" value="" placeholder=" " class="form-control" formControlName="name" id="offer-price-level-name-{{ i }}">
                                    <label class="required" for="offer-price-level-name-{{ i }}">{{'offer.price.level.name.value' | translate}}</label>
                                    <mat-error *ngIf="getPriceLevelControl(i).get('name').errors && (getPriceLevelControl(i).get('name').dirty || getPriceLevelControl(i).get('name').touched)">
                                        <div class="invalid-feedback">
                                            <div *ngIf="getPriceLevelControl(i).get('name').errors.required">{{ 'form.control.error.required.value' | translate }}</div>
                                        </div>
                                    </mat-error>
                                </div>
                            </div>

                        </div>
                        <div class="row marges ligne_form">
                            <div class="col_6">
                                <div class="form-group">
                                    <input type="text" value="" placeholder=" " class="form-control" formControlName="min" id="offer-price-level-min-{{ i }}">
                                    <label for="offer-price-level-min-{{ i }}" class="required">{{'offer.price.level.min.value' | translate}}</label>
                                    <mat-error *ngIf="getPriceLevelControl(i).get('min').errors && (getPriceLevelControl(i).get('min').dirty || getPriceLevelControl(i).get('min').touched)">
                                        <div class="invalid-feedback">
                                            <div *ngIf="getPriceLevelControl(i).get('min').errors.required">{{ 'form.control.error.required.value' | translate }}</div>
                                            <div *ngIf="getPriceLevelControl(i).get('min').errors.pattern">{{ 'form.control.error.pattern.value' | translate }}</div>
                                        </div>
                                    </mat-error>
                                </div>
                            </div>
                            <div class="col_6">
                                <div class="form-group">
                                    <input type="text" value="" placeholder=" " class="form-control" formControlName="max" id="offer-price-level-max-{{ i }}">
                                    <label for="offer-price-level-max-{{ i }}" class="required">{{'offer.price.level.max.value' | translate}}</label>
                                    <mat-error *ngIf="getPriceLevelControl(i).get('max').errors && (getPriceLevelControl(i).get('max').dirty || getPriceLevelControl(i).get('max').touched)">
                                        <div class="invalid-feedback">
                                            <div *ngIf="getPriceLevelControl(i).get('max').errors.required">{{ 'form.control.error.required.value' | translate }}</div>
                                            <div *ngIf="getPriceLevelControl(i).get('max').errors.pattern">{{ 'form.control.error.pattern.value' | translate }}</div>
                                        </div>
                                    </mat-error>
                                </div>
                            </div>
                        </div>
                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    <label>{{'offer.price.level.type.value' | translate}}</label>
                                    <div class="radio" *ngFor="let type of offerPriceLevelTypes">
                                        <div class="radio">
                                            <input type="radio" [value]="type.type" formControlName="type" class="form-control" id="priceLevelType-{{ type.type }}-{{ i }}" (ngModelChange)="handlePriceLevelValues(getPriceLevelControl(i))">
                                            <label for="priceLevelType-{{ type.type }}-{{ i }}">{{ type.label | translate: {currency: offer.currency.symbol} }}</label>
                                        </div>
                                    </div>
                                    <mat-error *ngIf="getPriceLevelControl(i).get('type').errors && (getPriceLevelControl(i).get('type').dirty || getPriceLevelControl(i).get('type').touched)">
                                        <div class="invalid-feedback">
                                            <div *ngIf="getPriceLevelControl(i).get('type').errors.required">{{ 'form.control.error.required.value' | translate }}</div>
                                        </div>
                                    </mat-error>
                                </div>
                            </div>
                        </div>
                        <ng-container *ngIf="getPriceLevelControl(i).get('type').valid">
                            <div class="row marges ligne_form">
                                <div class="col_6">
                                    <div class="form-group">
                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="value" id="offer-price-level-value-{{ i }}" appInputTextParsePrice [control]="getPriceLevelControl(i).get('value')">
                                        <label for="offer-price-level-value-{{ i }}">{{ (getPriceLevelControl(i).get('type').value === 'percent' ? 'offer.price.level.type.percent.value' : 'offer.price.level.type.price.ttc.value') | translate:{currency: offer.currency.symbol} }}</label>
                                        <mat-error *ngIf="getPriceLevelControl(i).get('value').errors && (getPriceLevelControl(i).get('value').dirty || getPriceLevelControl(i).get('value').touched)">
                                            <div class="invalid-feedback">
                                                <div *ngIf="getPriceLevelControl(i).get('value').errors.required">{{ 'form.control.error.required.value' | translate }}</div>
                                                <div *ngIf="getPriceLevelControl(i).get('value').errors.pattern">{{ 'form.control.error.pattern.value' | translate }}</div>
                                            </div>
                                        </mat-error>
                                    </div>
                                </div>
                            </div>
                            <ng-container *ngIf="getPriceLevelControl(i).get('type').value === 'price'">
                                <div class="row marges ligne_form">
                                    <div class="col_6">
                                        <div class="form-group">
                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="additionalValue" id="offer-price-level-additionalValue-{{ i }}" appInputTextParsePrice [control]="getPriceLevelControl(i).get('additionalValue')">
                                            <label for="offer-price-level-additionalValue-{{ i }}">{{ 'offer.price.level.type.price.ht.value' | translate:{currency: offer.currency.symbol} }}</label>
                                            <mat-error *ngIf="getPriceLevelControl(i).get('additionalValue').errors && (getPriceLevelControl(i).get('additionalValue').dirty || getPriceLevelControl(i).get('additionalValue').touched)">
                                                <div class="invalid-feedback">
                                                    <div *ngIf="getPriceLevelControl(i).get('additionalValue').errors.isRequired">{{ 'form.control.error.required.value' | translate }}</div>
                                                    <div *ngIf="getPriceLevelControl(i).get('additionalValue').errors.pattern">{{ 'form.control.error.pattern.value' | translate }}</div>
                                                </div>
                                            </mat-error>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    <label>{{'offer.price.level.increaseArea.value' | translate}}</label>
                                    <div class="radio" *ngFor="let increaseArea of offerPriceLevelIncreaseAreas">
                                        <div class="radio">
                                            <input type="radio" [value]="increaseArea.type" formControlName="priceIncreaseArea" class="form-control" id="priceIncreaseArea-{{ increaseArea.type }}-{{ i }}">
                                            <label for="priceIncreaseArea-{{ increaseArea.type }}-{{ i }}">{{ increaseArea.label | translate }}</label>
                                        </div>
                                    </div>
                                    <mat-error *ngIf="getPriceLevelControl(i).get('priceIncreaseArea').errors && (getPriceLevelControl(i).get('priceIncreaseArea').dirty || getPriceLevelControl(i).get('priceIncreaseArea').touched)">
                                        <div class="invalid-feedback">
                                            <div *ngIf="getPriceLevelControl(i).get('priceIncreaseArea').errors.required">{{ 'form.control.error.required.value' | translate }}</div>
                                        </div>
                                    </mat-error>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <!-- Suppression du palier -->

                    <button type="button" class="btn_cta btn_red btn_little remove_item" (click)="removePriceLevel(i)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </ng-container>

            <!-- Ajout d'un palier -->

            <button class="btn_cta btn_little" type="button" (click)="addPriceLevel()">{{ 'offer.price.level.add.action.value' | translate }}</button>
        </div>

    </div>

</form>
